import {nombreDeAcciones} from "constantes/nombreDeAcciones";

const datosDeEmpresaGeneral = {
    nombreEmpresa: "",
    direccionEmpresa: "",
    direccionNotificaciones: "",
    correoElectronico: "",
    telefono: "",
    telefono2: "",
    nombreEnlace: "",
    correoElectronicoMedio: "",
    telefonoMedio: "",
    patente: "",
    registro: "",
    folio: "",
    libro: "",
    archivoPatenteComercio: "",
    declaracionJurada: "",
    tipoPropietario: "",
    tipodeMedio: null,
};

// const datosDeEmpresaGeneral = {
//     nombreEmpresa: "PATITO S.A",
//     direccionEmpresa: "direccion",
//     direccionNotificaciones: "notificaciones",
//     correoElectronico: "patito@tse.org.gt",
//     telefono: "12345678",
//     telefono2: "",
//     nombreEnlace: "enlace",
//     correoElectronicoMedio: "patito@tse.org.gt",
//     telefonoMedio: "12345678",
//     patente: "1",
//     registro: "2",
//     folio: "3",
//     libro: "4",
//     archivoPatenteComercio: "",
//     declaracionJurada: "",
//     tipoPropietario: "1",
//     tipodeMedio: null,
// };

const personaIndividualGeneral = {
    nit: "",
    nombreEmiteFactura: "",
    constanciaRTU: "",
    noRegistro: "",
    numeroResolucion: "",
    folioRGAE: "",
    constanciaRGAE: "",
};

// const personaIndividualGeneral = {
//     nit: "82934614",
//     nombreEmiteFactura: "juana",
//     constanciaRTU: "",
//     noRegistro: "1",
//     numeroResolucion: "2",
//     folioRGAE: "3",
//     constanciaRGAE: "",
// };

const personaLegalGeneral = {
    razonSocial: "",
    nombreComercial: "",
    numeroConstitucion: "",
    fechaEscritura:  "",
    nombreNotario: "",
    numeroInscripcion: "",
    folio: "",
    libro: "",
    constitucionSociedad: "",
    cuiRepresentanteLegal: "",
    nombreRepresentante: "",
    fechaVigencia: "",
    folioRepresentante: "",
    libroRepresentante: "",
    registroRepresentante: "",
    certificacionRegistroMercantil: "",
}

// const personaLegalGeneral = {
//     razonSocial: "1",
//     nombreComercial: "2",
//     numeroConstitucion: "3",
//     fechaEscritura:  new Date(),
//     nombreNotario: "notario",
//     numeroInscripcion: "1",
//     folio: "2",
//     libro: "3",
//     constitucionSociedad: "",
//     cuiRepresentanteLegal: "1234567891234",
//     nombreRepresentante: "nombre",
//     fechaVigencia: new Date(),
//     folioRepresentante: "1",
//     libroRepresentante: "2",
//     registroRepresentante: "3",
//     certificacionRegistroMercantil: "",
// }


const arrendatarioGeneral = {
    esArrendatario: false,
    fechaInicioArrendamiento : "",
    fechaFinArrendamiento :  "",
    proPolitica : false,
    pdfContratoArrenda :  ""
}

const initialState = {
    datosDeEmpresa: { ...datosDeEmpresaGeneral},
    listadoPersonaIndividual: [],
    personaIndividual: {...personaIndividualGeneral},
    personaLegal: {...personaLegalGeneral},
    listadoDeCaracteristicasDelMedio: [],
    arrendatario: arrendatarioGeneral,
    idSolicitud: null,
    activeStep: 0,
    numberStep: 1,
};

export default (state = initialState, action ) => {
    switch (action.type) {

        case nombreDeAcciones.SET_DATA_COMPANY:
            return {
                ...state,
                datosDeEmpresa: {...action.payload.company},
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SET_DATA_INDIVIDUAL_PERSON_LIST:
            return {
                ...state,
                listadoPersonaIndividual: action.payload.listadoPersonaIndividual,
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SET_DATA_PERSON_ISSUING_THE_INVOICE:
            return {
                ...state,
                personaIndividual: {...action.payload.personaIndividual},
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.CLEAN_DATA_PERSON_ISSUING_THE_INVOICE:
            return {
                ...state,
                listadoPersonaIndividual: []
            }

        case nombreDeAcciones.SET_DATA_LEGAL_PERSON:
            return {
                ...state,
                personaLegal: {...action.payload.personaLegal},
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.CLEAN_DATA_LEGAL_PERSON:
            return {
                ...state,
                personaLegal: {...personaLegalGeneral},
            }

        case nombreDeAcciones.SET_DATA_CARACTERISTICAS_MEDIOS:
            return {
                ...state,
                listadoDeCaracteristicasDelMedio: action.payload.listadoDeCaracteristicasDelMedio,
            }

        case nombreDeAcciones.SET_DATA_ACTIVE_AND_NUMBER_STEP:
            return {
                ...state,
                activeStep: action.payload.activeStep,
                numberStep: action.payload.numberStep,
            }

        case nombreDeAcciones.SETEAR_ALL_REDUCER:
            return {
                datosDeEmpresa: {...action.payload.datosDeEmpresa},
                listadoPersonaIndividual: action.payload.listadoPersonaIndividual,
                personaLegal: {...action.payload.personaLegal},
                personaIndividual: {...action.payload.personaIndividual},
                arrendatario: {...action.payload.arrendatario},
                listadoDeCaracteristicasDelMedio: action.payload.listadoDeCaracteristicasDelMedio,
                idSolicitud: action.payload.idSolicitud,
                activeStep: 0,
                numberStep: 1,
            }

        case nombreDeAcciones.CLEAN_ALL_REDUCER:
            return {
                datosDeEmpresa: { ...datosDeEmpresaGeneral},
                listadoPersonaIndividual: [],
                personaIndividual: {...personaIndividualGeneral},
                personaLegal: {...personaLegalGeneral},
                arrendatario: {...arrendatarioGeneral},
                listadoDeCaracteristicasDelMedio: [],
                idSolicitud: null,
                activeStep: 0,
                numberStep: 1,
            }

        default:
            return state;
    }
}